import { Space } from '@billy/design-system'
import { ReactElement } from 'react'

import { ApplyColorToDocumentElements } from './elements/ApplyColorToDocumentElements'
import { DefaultColor } from './elements/DefaultColor'
import * as Styled from './styles'

export const DefaultColorSettings = (): ReactElement => (
  <Styled.DefaultColorSettingsWrapper>
    <DefaultColor />
    <Space />
    <ApplyColorToDocumentElements />
  </Styled.DefaultColorSettingsWrapper>
)
